import React from "react";

import { Grid } from "@mui/material";

import { ContainersConfigure, ESupplyChainOverviewTabs } from "../../../../../models/supply.chain.overview.configure";
import { useSupplyChainOverviewContext } from "../../context";
import ConfigWidget from "../ConfigWidget";

const ContainersConfig = () => {
  const { config, dashboard, handleWidgetConfigChange } = useSupplyChainOverviewContext();

  const configs: Array<keyof ContainersConfigure> = [
    "inbound",
    "atPort",
    "atDC",
    "containerDistributionByDestination",
    "containersStatuses",
    "containersByArrivalDate",
  ];

  return (
    <Grid container spacing={0}>
      {configs.map((label: keyof ContainersConfigure) => (
        <Grid item key={`shipmentsConfig-${label}`} xs={4}>
          <ConfigWidget
            handleChange={(value) => handleWidgetConfigChange(ESupplyChainOverviewTabs.CONTAINERS, label, value)}
            label={label}
            type={dashboard.containers?.graphs[label].type}
            value={config.containers[label] as boolean}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default ContainersConfig;
